<template>
  <!-- Template when overide specified on route node -->
  <component v-if="node.meta && node.meta.overrides && node.meta.overrides.submenutab"
    :is="node.meta.overrides.submenutab" :node="node" :hide="hide">
  </component>

  <!-- Template when overide set to false on route node -->
  <div v-else-if="node.meta && node.meta.overrides && node.meta.overrides.submenutab === false"></div>

  <!-- Normal template -->
  <SubMenuTabTemplate v-else :hide="hide" :icon="routeIcon(node)" :text="routeDisplayName(node)"
    :to="{ name: node.name, params: $route.params, query: $route.query, }">
  </SubMenuTabTemplate>
</template>


<script>
import SubMenuTabTemplate from "@/components/SingleUse/ComponentOverrides/submenu/SubMenuTab_template.vue";

export default {
  name: "SubMenuTab_Base",
  props: {
    node: Object,
    hide: Boolean,
  },
  components: {
    SubMenuTabTemplate
  },

  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {

  },

  computed: {

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>